export default __webpack_public_path__ + "static/media/history.19b229fe.jpg";